<template>
  <div class="product-details-video" @click="show = true">
    <img :src="video.thumbnail" class="product-details-video-thumbnail" />
    <div class="product-details-video-container">
      <div class="product-details-video-button">
        <span></span>
      </div>
      <div class="text-center">{{ video.title }}</div>
    </div>

    <Modal :show="show" @close="show = false" width="95%" maxWidth="900px" theme="dark">
      <Video :thumbnail="video.thumbnail" :video="video.code" />
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/shared/modal/Modal';
import Video from './Video';

export default {
  name: 'ProductDetailsVideo',
  components: { Modal, Video },
  props: { video: Object },
  data() {
    return {
      show: false,
    };
  },
};
</script>
